import api from '../../../tools/api-tools'
import { mainWebPostData } from '../../../config/net'
import { mainWebImgPath } from '../../../tools/img-tools'
import resUrl from './resource-url'
// import './index.mock'
class RechargeMessage {
  loadData (id) {
    return api.post(resUrl.detail.url, mainWebPostData(resUrl.detail.method, {
      goodsId: id,
      goodsType: '1'
    })).then(res => {
      let model = JSON.parse(res.data.Model || '{}')
      let imgItems = []
      let rechargeMessage = []
      for (let item of model.ListPic) {
        imgItems.push(mainWebImgPath(item.PicUrl))
      }
      for (let item of model.ListQuantityBuyItems) {
        rechargeMessage.push({
          id: item.ProductId,
          title: `${item.ShowMoney}元`,
          desc: item.ShowDesc,
          commend: item.IsDefault === 1,
          quantity: item.Quantity
        })
      }
      return {
        imgItems,
        rechargeMessage
      }
    }).catch(e => {
    })
  }
}

export default RechargeMessage



// WEBPACK FOOTER //
// ./src/model/rechage/message/index.js